export default "__VITE_ASSET__CAJnNuqk__"